// extracted by mini-css-extract-plugin
module.exports = {"s1ah2waq":"s1ah2waq"};